import React, { useState, useEffect } from "react";
import { FaStar, FaGoogle } from "react-icons/fa";
import "../styles/GoogleReviews.css";

const sampleReviews = [
  {
    name: "Luciana Landim",
    comment: "Maravilhosa essa garota! Profissional formidável! Super indico!",
  },
  {
    name: "Simone Agostini",
    comment: "Ótima instrutora!!! O resultado é garantido... super indico.",
  },
  {
    name: "Renata M.",
    comment:
      "A Jéssica é super atenciosa. Estou adorando minhas aulas de Pilates!",
  },
  {
    name: "Camila",
    comment: "Equipamentos modernos, aula personalizada e muita dedicação.",
  },
  {
    name: "Guilherme Varjão",
    comment: "Aulas incríveis, de alta qualidade com alto astral.",
  },
];

const GoogleReviews = ({ rating, link }) => {
  const [current, setCurrent] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setCurrent((prev) => (prev + 1) % sampleReviews.length);
        setFade(true);
      }, 500); // fade-out duration
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="reviews-carousel">
      <div className="stars">
        {Array.from({ length: Math.floor(rating) }, (_, i) => (
          <FaStar key={i} />
        ))}
      </div>
      <div className="review-slide" style={{ opacity: fade ? 1 : 0 }}>
        <p className="review-comment">“{sampleReviews[current].comment}”</p>
        <p className="review-name">– {sampleReviews[current].name}</p>
      </div>
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className="btn-reviews"
      >
        <FaGoogle style={{ marginRight: "8px" }} />
        Ver todas as avaliações
      </a>
    </div>
  );
};

export default GoogleReviews;
